<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";


  .container-card{
    width: 120px;
  }

  .grid-view-item:hover{
    cursor: pointer;
    background-color: #eeee;
  }

  .inactive{
    background-color: #eeee;
  }

  .vx-card__body{
    padding: 7px!important;
  }
</style>
<template>
  <div>
    <vx-card class="m-2">
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row my-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Name')}}</label>
        <vs-input class="w-full" v-model="filters.name" />
      </div>
      <div class="vx-col">
        <label  class="font-bold">{{$t('Labels.Cuantity')}}</label>
        <vs-slider v-model="filters.cuantity" :min="0" :max="100"/>
      </div>
      <div class="vx-col w-full text-center sm:inline-block sm:w-auto">
        <vs-button @click="getResponse()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    </vx-card>
    <vx-card class="m-2">
    <div class="vx-row my-5">
      <div class="vx-col">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="byColumn" :reduce="v => v.value"/>
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder === 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder !== 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>   
      </div>
    </div>
    <div class="text-center py-6" v-if="response.length === 0">{{$t('Labels.NoData')}}</div>
    <div class="grid-container">
      <div class="vx-row match-height mt-4">
        <div :key="item.objectID" @click="goToDetail(item.uuid)" class="vx-col lg:w-1/5 sm:w-1/2 w-full" v-for="item in response">
            <vx-card class="grid-view-item mb-base overflow-hidden py-2">
              <div class="text-center mb-2">
                <div class="w-5 h-5 inline-block rounded-sm align-middle" :style="{ 'background-color': item.color }"></div>
                <div class="ml-2 inline-block align-middle">{{item.color || 'N/A'}}</div>
              </div>
              <div class="text-center">{{item.name}}</div>
              <div class="text-xs text-center mb-2">{{$t('Labels.Name')}}</div>
              <div class="text-center"> {{item.total_devices}}</div>
              <div class="text-xs text-center">{{$t('Labels.LuminariesCount')}}</div>
            </vx-card>
        </div>
      </div>
       <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
    </div>
    </vx-card>
  </div>
</template>
<script>
import {request} from '@/request.js'
import statusItem from '@/components/statusItem/statusItem.vue'
import Datepicker from 'vuejs-datepicker'
import {formatDate, empty} from '@/helpers.js'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'

export default {
  components: {
    statusItem,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      selected:[],
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'name',
        byOrder: 'ASC',
        cuantity: [0, 0],
        name: null,
        uuid: this.$route.query.circuit !== undefined ? this.$route.query.circuit : null
      },
      columnOrders:[
        {label: this.$t('Labels.Name'), value: 'name'},
        {label: this.$tc('Labels.Cuantity', 0), value: 'total'}
      ],
      byColumn: 'updatedAt',
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const filter = {}
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder
      filter.name = this.filters.name
      filter.uuid = this.filters.uuid
      
      if (this.filterLastSeen) filter.last_seen = formatDate(this.filters.last_seen)

      const params = {
        url: 'luminaires_circuits',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.setPages(response.data.data.count)
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
      
    },
    resetFilters () {
      this.filters.name = null
      this.filters.uuid = null
      this.filters.cuantity = [0, 0]
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    goToDetail (uuid) {
      if (!empty(uuid)) window.location.href = `/circuitos/${uuid}`
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    }
  },

  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.getResponse()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>